module.exports = " <div id=cookieapp class=or-cookie v-show=showCookieApp role=form aria-label=\"Cookie consent\"> <cookiebanner v-show=!showSettings></cookiebanner> <cookiesettings v-show=showSettings :data.sync=items></cookiesettings> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/kokuapp/cookieApp.vue
// module id = 233
// module chunks = 13 14